module.exports = __webpack_public_path__ + "e87ce4734d841632da9d9d226fc1edeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/App/screens/Orders/screens/Confirmation/images/fallo_pago.png
// module id = 1470
// module chunks = 0